import { Modal, DatePicker, message, InputNumber, Form, Button } from "antd";
import { useState, useEffect } from "react";
import { serverFetch } from "../../server";
import { CloseOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { isMobile } from "../../extensions/design";
import { strDate2Server } from "../../extensions/utils"
import { CLIENT_NESTED_ANTD_MODAL_Z_INDEX } from "./client-nested-modal-zindex";

const UnfreezeModal = ({ saleId, onClose }) => {
  const [form] = Form.useForm();
  const [date, setStartDate] = useState(null);
  const [dateEnd, setEndDate] = useState(null);
  const [days, setDays] = useState(null);
  const [loading, setLoading] = useState(false);
  const [minDays, setMinDays] = useState(null)
  const [maxDays, setMaxDays] = useState(null);

  useEffect(() => {
    const today = dayjs();
    setStartDate(today);
    setEndDate(today);
    form.setFieldsValue({ dateStart: today, dateEnd: today });
    getProductFreezeDays();
  }, []);
const getProductFreezeDays = () => {
    setLoading(true);
    serverFetch(`sale/${saleId}`, {
      method: "GET",
    })
      .then((data) => {
        serverFetch(`product/${data.productId}`, {
          method: "GET",
        })
          .then((data) => {
            setMinDays(data.freezMin);
            setMaxDays(data.freezSrok);
            setLoading(false);
          })
          .catch((e) => {
            setLoading(false);
            message.error(e.userMessage);
          })
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(() => {
    if (date && dateEnd) {
      const diff = dateEnd.startOf('day').diff(date.startOf('day'), "day"); 
      setDays(diff > 0 ? diff : 0);
    }
  }, [date, dateEnd]);

  const onStatusFrozen = () => {
    const values = form.getFieldsValue();
    const dateEndStr = strDate2Server(values.dateEnd)
    const bodyData = Array.isArray(saleId)
      ? { saleIds: saleId, date: dateEndStr }
      : { saleId, date: dateEndStr };
    setLoading(true);
    serverFetch("sale/SetUnfrozen", {
      method: "POST",
      bodyData,
    })
      .then((res) => {
        setLoading(false);
        const payload = res?.errors ?? res?.results ?? res;
        onClose(true, payload);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return !isMobile ?
    <Modal
      title="Разморозить абонемент"
      open
      zIndex={CLIENT_NESTED_ANTD_MODAL_Z_INDEX}
      onCancel={() => onClose(false)}
      onOk={onStatusFrozen}
      okText="Сохранить"
      cancelText="Закрыть"
      width={400}
    >
      <Form form={form} colon={false} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }}>
        <Form.Item label="Начало заморозки" name="dateStart" labelCol={{ span: 13 }}>
          <DatePicker
            value={date}
            disabled
            onChange={(d) => { setStartDate(d); form.setFieldsValue({ dateStart: d }); }}
            className="modal-date"
            format="DD.MM.YYYY"
          />
        </Form.Item>
        <Form.Item label="Окончание заморозки" name="dateEnd" labelCol={{ span: 13 }}>
          <DatePicker
            value={dateEnd}
            onChange={(d) => { setEndDate(d); form.setFieldsValue({ dateEnd: d }); }}
            className="modal-date"
            format="DD.MM.YYYY"
          />
        </Form.Item>
        <Form.Item label="Кол-во дней заморозки" labelCol={{ span: 13 }}>
          <InputNumber
            value={days}
            onChange={(value) => {
              setDays(value);
              const newDateEnd = date ? dayjs(date).add(value, 'day') : null;
              setEndDate(newDateEnd);
              form.setFieldsValue({ dateEnd: newDateEnd, daysFreezed: value });
            }}
            min={minDays}
            max={maxDays}
            style={{ width: "80px" }}
          />
        </Form.Item>
        <div style={{ marginTop: 20 }}>
          <Form.Item label="Общий срок с учетом текущей" labelCol={{ span: 17 }}>{days}</Form.Item>
          <Form.Item label="Минимальный срок по абонементу" labelCol={{ span: 19 }}>{minDays}</Form.Item>
          <Form.Item label="Максимальный срок по абонементу" labelCol={{ span: 19 }}> {maxDays}</Form.Item>
        </div>
      </Form>
    </Modal>
  : <div className="sport-modal">
  <div className="sport-modal-overlay">
    <div className="sport-modal-content">
      <div className="sport-modal-title">
        <span>Разморозить абонемент</span>
        <CloseOutlined
          onClick={() => onClose(false)}
          className="sport-section-title-close client-close-outlined-button-style"
        />
      </div>

      <Form form={form} labelCol={{ xs: 10}} wrapperCol={{ xs: 14}} colon={false} layout="inline" className="client-abon-form-item">
        <Form.Item label="Начало заморозки" name="dateStart" className="client-abon-form-item">
          <DatePicker value={date} disabled className="modal-date client-abon-form-item" format="DD.MM.YYYY"
            onChange={(d) => { setStartDate(d); form.setFieldsValue({ dateStart: d }); }}/>
        </Form.Item>
        <Form.Item label="Окончание замор." name="dateEnd" className="client-abon-form-item-with-margin">
          <DatePicker value={dateEnd} className="modal-date client-abon-form-item" format="DD.MM.YYYY"
            onChange={(d) => { setEndDate(d); form.setFieldsValue({ dateEnd: d }); }}
          />
        </Form.Item>
        <Form.Item label="Кол-во дней замор." className="client-abon-form-item-with-margin">
          <InputNumber value={days} min={minDays} max={maxDays} className="client-abon-form-item"
            onChange={(value) => {
              setDays(value);
              const newDateEnd = date ? dayjs(date).add(value, 'day') : null;
              setEndDate(newDateEnd);
              form.setFieldsValue({ dateEnd: newDateEnd, daysFreezed: value });
            }}
          />
        </Form.Item>
        <Form.Item label="Общий срок с тек." className="client-abon-form-item">{days}</Form.Item>
        <Form.Item label="Мин. срок по абон." className="client-abon-form-item">{minDays}</Form.Item>
        <Form.Item label="Макс. срок по абон." className="client-abon-form-item"> {maxDays}</Form.Item>
        <Button className="client-abon-form-item-with-margin" onClick={onStatusFrozen} loading={loading}> Сохранить </Button>
      </Form>
    </div>
  </div>
</div>
};

export default UnfreezeModal;